import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Root } from './banner-root.js';
export { Button, ButtonLink } from './banner-button.js';
export { Link } from './banner-link.js';
export { Message } from './banner-message.js';

/**
 * Full Width Banner: spans full page at the top of the screen.
 *
 * @compose { "root": true }
 * @see https://fpl.figma.design/components/banner/
 */
const FullWidth = forwardRef((props, ref) => (jsx(Root, { "data-fpl-component": "", ref: ref, type: "full-width", ...props })));
FullWidth.displayName = 'Banner.FullWidth';
/**
 * Inline Banner: used in left sidebar.
 *
 * @compose { "root": true }
 * @see https://fpl.figma.design/components/banner/
 */
const Inline = forwardRef((props, ref) => (jsx(Root, { "data-fpl-component": "", ref: ref, type: "inline", ...props })));
Inline.displayName = 'Banner.Inline';
/**
 * Informational Banner: used full-bleed in left sidebar
 *
 * @compose { "root": true }
 * @see https://fpl.figma.design/components/banner/
 */
const Informational = forwardRef((props, ref) => (jsx(Root, { "data-fpl-component": "", ref: ref, type: "informational", ...props })));
Informational.displayName = 'Banner.Informational';
/**
 * Inset Modal Banner: used inside modals. onDismiss is not accepted for this variant.
 *
 * @compose { "root": true }
 * @see https://fpl.figma.design/components/banner/
 */
const InsetModal = forwardRef((props, ref) => jsx(Root, { "data-fpl-component": "", ref: ref, type: "inset-modal", ...props }));
InsetModal.displayName = 'Banner.InsetModal';
/**
 * Inset Banner: spans main content areas
 *
 * @compose { "root": true }
 * @see https://fpl.figma.design/components/banner/
 */
const Inset = forwardRef((props, ref) => (jsx(Root, { "data-fpl-component": "", ref: ref, type: "inset", ...props })));
Inset.displayName = 'Banner.Inset';

export { FullWidth, Informational, Inline, Inset, InsetModal };
//# sourceMappingURL=banner.js.map
